/* ==========================================================================
   TUYO — customizacoes do tema (extraidas de snippets/tuyo-settings.liquid
   em 17/09/2026 para virar asset CACHEAVEL em vez de JS inline em
   toda pagina). O que depende de Liquid ficou inline como CSS var.
   Ordem dos blocos preservada exatamente como estava no snippet.
   ========================================================================== */

/* ======== bloco-2 ======== */
(function() {
    // TUYO: Helper — dispara sequência pointerdown/pointerup/click que o Flickity processa.
    // (.click() simples não basta — Flickity escuta pointer events)
    function fireFlickityClick(el) {
      if (!el) return;
      try {
        el.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, cancelable: true, pointerType: 'mouse', isPrimary: true }));
        el.dispatchEvent(new PointerEvent('pointerup', { bubbles: true, cancelable: true, pointerType: 'mouse', isPrimary: true }));
        el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } catch(e) {
        el.click();
      }
    }

    // TUYO: navega o slider principal direto pra mídia (data-id) via Flickity selectCell.
    // Preciso usar selectCell (não o thumb original asNavFor) porque o slider filtrado
    // tem 5 células e os thumbs originais 80 — o asNavFor desalinha o índice.
    function tuyoGoToMedia(mediaId) {
      if (!mediaId) return;
      var slider = document.querySelector('.product-gallery__media-slider');
      if (!slider) return;
      var target = slider.querySelector('.product-gallery__media-slide[data-id="' + mediaId + '"]');
      try {
        var F = window.theme && window.theme.Flickity;
        var flkty = (F && F.data) ? F.data(slider) : null;
        if (flkty && target) { flkty.selectCell(target, false, false); return; }
      } catch (e) {}
      // fallback: clique no thumb original
      var origThumb = document.querySelector('.product-single__thumbnails .product-single__thumbnail[data-id="' + mediaId + '"]');
      if (origThumb) fireFlickityClick(origThumb);
    }

    // TUYO: Cria thumbs verticais em desktop (>= 1000px) baseado nos thumbs originais Flickity.
    // Cada click dispara click no thumb original (que está configurado como asNavFor do slider).
    function buildTuyoThumbs() {
      var isDesktop = window.matchMedia('(min-width: 1000px)').matches;
      var gallery = document.querySelector('.product-gallery');
      if (!gallery) return;

      var existing = gallery.querySelector('.tuyo-thumbs-vertical');
      if (!isDesktop) { existing && existing.remove(); return; }
      if (existing) return; // já construído

      var origThumbs = gallery.querySelectorAll('.product-single__thumbnails .product-single__thumbnail');
      if (!origThumbs.length) return;

      var container = document.createElement('div');
      container.className = 'tuyo-thumbs-vertical';

      origThumbs.forEach(function(orig, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tuyo-thumb' + (orig.classList.contains('is-nav-selected') ? ' is-active' : '');
        btn.setAttribute('data-tuyo-thumb-index', idx);
        btn.setAttribute('data-tuyo-thumb-mediaid', orig.getAttribute('data-id') || '');
        btn.setAttribute('aria-label', orig.querySelector('a')?.getAttribute('aria-label') || ('Image ' + (idx + 1)));

        var link = orig.querySelector('a.product-single__thumbnail-link');
        var src = link ? link.getAttribute('href') : '';
        if (src && src.startsWith('//')) src = 'https:' + src;
        // Pega versão menor da imagem (180x)
        if (src) src = src.replace(/_(2048|1024|800|600)x\./, '_180x.');

        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);

        btn.addEventListener('click', function() {
          tuyoGoToMedia(btn.getAttribute('data-tuyo-thumb-mediaid'));
        });

        container.appendChild(btn);
      });

      gallery.appendChild(container);

      // Sincroniza altura do container de thumbs com a altura do slider principal
      function syncHeight() {
        var slider = gallery.querySelector('.product-gallery__media-slider');
        if (slider && container) {
          var h = slider.getBoundingClientRect().height;
          if (h > 100) container.style.height = h + 'px';
        }
      }
      syncHeight();
      setTimeout(syncHeight, 100);
      setTimeout(syncHeight, 500);
      window.addEventListener('resize', syncHeight);

      // Observa mudanças no thumbs original pra sincronizar estado active
      var mo = new MutationObserver(function() {
        origThumbs.forEach(function(orig, idx) {
          var customBtn = container.children[idx];
          if (!customBtn) return;
          if (orig.classList.contains('is-nav-selected')) {
            customBtn.classList.add('is-active');
            // Scroll into view dentro do container
            if (customBtn.scrollIntoView) {
              var cR = container.getBoundingClientRect();
              var bR = customBtn.getBoundingClientRect();
              if (bR.top < cR.top || bR.bottom > cR.bottom) {
                customBtn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
              }
            }
          } else {
            customBtn.classList.remove('is-active');
          }
        });
        // Atualiza também o estado dos dots
        syncDotsActive();
      });
      origThumbs.forEach(function(o) { mo.observe(o, { attributes: true, attributeFilter: ['class'] }); });
    }

    // TUYO: Filtra thumbs pra mostrar SÓ os da variante atual
    var productData = null;
    function loadProductData() {
      var productInfo = document.querySelector('product-info, [data-product-handle]');
      var handle = productInfo?.dataset?.productHandle;
      if (!handle) return Promise.resolve(null);
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .catch(function() { return null; });
    }

    function getCurrentVariantId() {
      // Procura input hidden com name="id" dentro do form principal do produto
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return input?.value;
    }

    function slugifyColor(s) {
      return String(s || '').toLowerCase().trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
    }

    function getMediaIdsForVariantCore(variantId) {
      if (!productData || !productData.media || !productData.variants) return null;
      var variant = productData.variants.find(function(v) { return String(v.id) === String(variantId); });
      if (!variant) return null;

      // 1. Tenta vinculação oficial Shopify (media.variant_ids contendo a variante)
      var byVariantIds = [];
      productData.media.forEach(function(m) {
        var linked = (m.variant_ids && m.variant_ids.indexOf(variant.id) >= 0);
        var isFeatured = variant.featured_media && variant.featured_media.id === m.id;
        if (linked || isFeatured) byVariantIds.push(String(m.id));
      });
      if (byVariantIds.length > 1) return byVariantIds;

      // 2. Fallback: convenção TUYO — tag #cor_<slug> no alt text
      // Tenta cada option do variant pra descobrir qual é a "cor"
      var optionValues = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      var byAlt = [];
      for (var i = 0; i < optionValues.length; i++) {
        var slug = slugifyColor(optionValues[i]);
        if (!slug) continue;
        var tag = '#cor_' + slug;
        var matches = [];
        productData.media.forEach(function(m) {
          if (m.alt && m.alt.toLowerCase().indexOf(tag) >= 0) {
            matches.push(String(m.id));
          }
        });
        if (matches.length > byAlt.length) byAlt = matches;
      }
      if (byAlt.length > 0) {
        // Garante que a featured esteja incluída
        if (variant.featured_media) {
          var fid = String(variant.featured_media.id);
          if (byAlt.indexOf(fid) < 0) byAlt.unshift(fid);
        }
        return byAlt;
      }

      // 3. Último fallback: só a featured media
      return variant.featured_media ? [String(variant.featured_media.id)] : null;
    }

    // TUYO: media ids dos vídeos de TAMANHO (#tamanho_<slug> no alt) — color-agnósticos,
    // sempre no FIM da galeria, em qualquer cor.
    function getTuyoSizeMediaIds() {
      if (!productData || !productData.media) return [];
      var ids = [];
      productData.media.forEach(function(m) {
        if (m.alt && m.alt.toLowerCase().indexOf('#tamanho_') >= 0) ids.push(String(m.id));
      });
      return ids;
    }
    // TUYO: wrapper — anexa os vídeos de tamanho ao FIM da allow-list, valendo para os
    // 3 caminhos do filtro de cor, sem alterar o filtro de cor das imagens.
    function getMediaIdsForVariant(variantId) {
      var allowed = getMediaIdsForVariantCore(variantId);
      if (!allowed) return allowed; // null => tema mostra tudo (vídeo já incluso)
      getTuyoSizeMediaIds().forEach(function(id) {
        if (allowed.indexOf(id) < 0) allowed.push(id);
      });
      return allowed;
    }

    function filterTuyoThumbs() {
      var variantId = getCurrentVariantId();
      var allowed = getMediaIdsForVariant(variantId);
      var container = document.querySelector('.tuyo-thumbs-vertical');
      if (container) {
        var thumbs = container.querySelectorAll('.tuyo-thumb[data-tuyo-thumb-mediaid]');
        thumbs.forEach(function(t) {
          var id = t.getAttribute('data-tuyo-thumb-mediaid');
          if (!allowed || allowed.indexOf(id) >= 0) t.style.display = '';
          else t.style.display = 'none';
        });
      }
      // Filtra o slider principal (foto grande) — só as fotos da variante
      filterMainSlides(allowed);
      // Reconstrói os dots conforme as medias visíveis
      buildTuyoDots(allowed);
    }

    // TUYO: camada de cobertura no .product-gallery (NÃO no slider — dentro do slider
    // a opacity trava por causa do Flickity). SEM CSS transition (transition também trava).
    // Esconde o flash do swap de imagem na troca de variante.
    var tuyoFirstFilter = true;
    function tuyoGetCover() {
      var gallery = document.querySelector('.product-gallery');
      if (!gallery) return null;
      if (getComputedStyle(gallery).position === 'static') gallery.style.position = 'relative';
      var ov = document.getElementById('tuyo-gallery-cover');
      if (!ov) {
        ov = document.createElement('div');
        ov.id = 'tuyo-gallery-cover';
        gallery.appendChild(ov);
      }
      // CSS já posiciona em top:0,left:0,100%,100% — cobre a galeria INTEIRA (slider+thumbs+dots)
      return ov;
    }
    // Cobre instantâneo (classe .tuyo-covering = opacity 1 sem transition) ou revela com
    // fade (remover a classe = transition CSS 0.30s pra opacity 0). O fade roda no browser
    // do usuário (em aba focada); CSS transition é o jeito padrão e confiável.
    function tuyoCover(show) {
      var ov = tuyoGetCover();
      if (!ov) return;
      if (show) ov.classList.add('tuyo-covering');   // branco instantâneo
      else ov.classList.remove('tuyo-covering');     // fade-in da nova foto
    }

    // TUYO: força o swap pra cor X SINCRONAMENTE (no clique, antes do tema processar).
    // Filtra os slides por #cor_<slug>, recarrega o Flickity e snapa pra primeira foto da cor.
    // Assim o slide do tema não tem o que animar — o swap já está feito atrás do cover.
    function tuyoForceSwapToColor(colorName) {
      if (!colorName) return;
      var slug = String(colorName).toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      var tag = '#cor_' + slug;
      var slider = document.querySelector('.product-gallery__media-slider');
      if (!slider) return;
      var slides = slider.querySelectorAll('.product-gallery__media-slide');
      var firstVisible = null;
      slides.forEach(function(s) {
        var img = s.querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
        // TUYO: vídeo de TAMANHO é color-agnóstico -> sempre visível, mas nunca vira o slide inicial.
        var isSize = alt.indexOf('#tamanho_') >= 0;
        var match = isSize || alt.indexOf(tag) >= 0;
        if (match) {
          s.classList.remove('tuyo-hide');
          s.style.removeProperty('display');
          if (!firstVisible && !isSize) firstVisible = s;
        } else {
          s.classList.add('tuyo-hide');
          s.style.setProperty('display', 'none', 'important');
        }
      });
      try {
        var F = window.theme && window.theme.Flickity;
        var flkty = (F && F.data) ? F.data(slider) : null;
        if (flkty) {
          flkty.options.cellSelector = '.product-gallery__media-slide:not(.tuyo-hide)';
          flkty.options.wrapAround = true;
          flkty.reloadCells();
          flkty.resize();
          if (firstVisible) flkty.selectCell(firstVisible, false, true);
          else flkty.select(0, false, true);
          try { flkty.isAnimating = false; flkty.positionSliderAtSelected(); } catch (e) {}
        }
      } catch (e) {}
    }

    // TUYO: filtra o slider Flickity pra conter só as fotos da variante atual.
    // Usa cellSelector (exclui .tuyo-hide) + reloadCells — assim o Flickity navega
    // SÓ pelas fotos da variante e faz loop (wrapAround). Instância via window.theme.Flickity.
    function filterMainSlides(allowed) {
      var slider = document.querySelector('.product-gallery__media-slider');
      if (!slider) return;
      // (O cover é gerenciado só pelo clique do swatch — um ciclo limpo, sem re-disparo aqui.)
      var slides = slider.querySelectorAll('.product-gallery__media-slide');
      slides.forEach(function(s) {
        var id = s.getAttribute('data-id');
        var ok = !allowed || allowed.indexOf(id) >= 0;
        if (ok) {
          s.classList.remove('tuyo-hide');
          s.style.removeProperty('display');
        } else {
          s.classList.add('tuyo-hide');
          s.style.setProperty('display', 'none', 'important');
        }
      });
      try {
        var F = window.theme && window.theme.Flickity;
        var flkty = (F && F.data) ? F.data(slider) : null;
        if (flkty) {
          flkty.options.cellSelector = '.product-gallery__media-slide:not(.tuyo-hide)';
          flkty.options.wrapAround = true; // loop infinito dentro da variante
          flkty.reloadCells();
          flkty.resize();
          flkty.select(0, false, true);
          // Snap instantâneo só aqui (troca de variante, escondida pelo cover);
          // a navegação foto-a-foto desliza normalmente (selectCell animado).
          try { flkty.positionSliderAtSelected(); } catch (e) {}
          // Liga sync no 'change'. Se estiver trocando de VARIANTE (flag _tuyoVC), faz snap
          // instantâneo (mata o slide animado, que fica escondido pelo cover). Na navegação
          // foto-a-foto (sem flag) deixa deslizar normalmente.
          if (!flkty._tuyoSyncBound) {
            flkty.on('change', function() {
              if (window._tuyoVC) {
                try { flkty.isAnimating = false; flkty.positionSliderAtSelected(); } catch (e) {}
              }
              syncDotsActive();
            });
            flkty.on('settle', syncDotsActive);
            flkty._tuyoSyncBound = true;
          }
          // Estado inicial após filtrar
          syncDotsActive();
        }
      } catch (e) {}
      tuyoFirstFilter = false;
    }

    // TUYO: Dots de navegação abaixo do slider principal
    function buildTuyoDots(allowedMediaIds) {
      var gallery = document.querySelector('.product-gallery');
      var slider = document.querySelector('.product-gallery__media-slider');
      if (!gallery || !slider) return;

      // Fallback: se não tem allowed (sem filter), pega todos os media ids dos thumbs originais
      if (!allowedMediaIds || !allowedMediaIds.length) {
        var allOrig = document.querySelectorAll('.product-single__thumbnails .product-single__thumbnail');
        allowedMediaIds = Array.from(allOrig).map(function(t) { return t.getAttribute('data-id'); });
      }

      var dotsContainer = gallery.querySelector('.tuyo-slider-dots');
      if (!dotsContainer) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'tuyo-slider-dots';
        gallery.appendChild(dotsContainer);
      }
      // Limpa
      dotsContainer.innerHTML = '';

      // Pega media id da slide atualmente selecionada
      var activeMediaId = null;
      var activeOrig = document.querySelector('.product-single__thumbnails .product-single__thumbnail.is-nav-selected');
      if (activeOrig) activeMediaId = activeOrig.getAttribute('data-id');

      allowedMediaIds.forEach(function(mediaId, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tuyo-slider-dot';
        dot.setAttribute('data-tuyo-dot-mediaid', mediaId);
        dot.setAttribute('aria-label', 'Slide ' + (idx + 1));
        if (mediaId === activeMediaId) dot.classList.add('is-active');

        dot.addEventListener('click', function() {
          tuyoGoToMedia(mediaId);
        });

        dotsContainer.appendChild(dot);
      });
    }

    // Sincroniza active state dos dots E dos thumbs custom pelo slide SELECIONADO
    // do slider principal (data-id). NÃO usa o is-nav-selected dos thumbs originais
    // porque o asNavFor desalinha quando filtramos as células (5 no slider vs 80 nos thumbs orig).
    function syncDotsActive() {
      var sel = document.querySelector('.product-gallery__media-slide.is-selected');
      var activeMediaId = sel ? sel.getAttribute('data-id') : null;
      document.querySelectorAll('.tuyo-slider-dot').forEach(function(d) {
        d.classList.toggle('is-active', d.getAttribute('data-tuyo-dot-mediaid') === activeMediaId);
      });
      document.querySelectorAll('.tuyo-thumb[data-tuyo-thumb-mediaid]').forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-tuyo-thumb-mediaid') === activeMediaId);
      });
    }

    // TUYO: Move .product-badge pra dentro do slider principal
    // Atualmente ela é child direto do .product-gallery — em desktop cai sobre o primeiro thumb
    function moveBadgeToSlider() {
      var gallery = document.querySelector('.product-gallery');
      var slider = document.querySelector('.product-gallery__media-slider');
      if (!gallery || !slider) return;
      var badge = gallery.querySelector(':scope > .product-badge');
      if (badge && badge.parentElement !== slider) {
        slider.appendChild(badge);
        badge.classList.add('tuyo-badge-moved');
      }
    }

    // TUYO: Esconde o .product-single__thumbnails (Flickity original) via inline style
    // (necessário porque o Flickity setta position:relative inline que vence o CSS)
    function hideOriginalThumbs() {
      var orig = document.querySelector('.product-single__thumbnails');
      if (!orig) return;
      orig.style.setProperty('position', 'absolute', 'important');
      orig.style.setProperty('left', '-10000px', 'important');
      orig.style.setProperty('top', '-10000px', 'important');
      orig.style.setProperty('width', '1px', 'important');
      orig.style.setProperty('height', '1px', 'important');
      orig.style.setProperty('opacity', '0', 'important');
      orig.style.setProperty('overflow', 'hidden', 'important');
      orig.style.setProperty('pointer-events', 'auto', 'important');
      orig.style.setProperty('margin', '0', 'important');
      orig.style.setProperty('padding', '0', 'important');
    }

    function init() {
      buildTuyoThumbs();
      // NÃO gera dots aqui — espera productData carregar pra já vir filtrado (evita flick de 50 dots)
      moveBadgeToSlider();
      hideOriginalThumbs();
      // Troca de cor (clique no swatch): cobre branco INSTANTÂNEO (capture phase, antes do swap).
      // O uncover (fade) acontece no evento 'settle' do Flickity — depois que o slide assenta
      // na nova foto. Fallback: descobre em 1200ms caso o settle não dispare.
      document.addEventListener('click', function(e) {
        var sw = e.target.closest('.tuyo-bottle-picker .radio__button, .tuyo-bottle-picker label, .tuyo-bottle-picker input[type=radio]');
        if (!sw) return;
        window._tuyoVC = true;                 // marca troca de variante → snap no 'change' do tema
        tuyoCover(true);                       // branco instantâneo
        // Descobre a cor clicada e força o swap SINCRONAMENTE (antes do tema processar)
        var btn = sw.closest('.radio__button');
        var input = (sw.tagName === 'INPUT') ? sw : (btn ? btn.querySelector('input[type=radio]') : null);
        var colorVal = input ? input.value : null;
        tuyoForceSwapToColor(colorVal);        // swap síncrono — slider já está na nova cor atrás do branco
        clearTimeout(window._tuyoUncoverT);
        window._tuyoUncoverT = setTimeout(function() {
          window._tuyoVC = false;
          tuyoCover(false);                    // revela direto a nova foto (já swapada)
        }, 320);                               // só precisa segurar enquanto o paint assenta
      }, true);
      // Re-aplica em timeouts pra garantir após Flickity terminar de inicializar
      setTimeout(hideOriginalThumbs, 300);
      setTimeout(hideOriginalThumbs, 1000);
      // Carrega dados do produto pra mapear variant → media
      loadProductData().then(function(data) {
        productData = data;
        filterTuyoThumbs();
        // Reage a mudanças no input de variante
        var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
        if (variantInput) {
          variantInput.addEventListener('change', filterTuyoThumbs);
          var lastVal = variantInput.value;
          setInterval(function() {
            if (variantInput.value !== lastVal) {
              lastVal = variantInput.value;
              filterTuyoThumbs();
            }
          }, 300);
        }
      });
      // Observer global do thumbs original pra sincronizar dots
      var origThumbs = document.querySelectorAll('.product-single__thumbnails .product-single__thumbnail');
      var moGlobal = new MutationObserver(syncDotsActive);
      origThumbs.forEach(function(o) { moGlobal.observe(o, { attributes: true, attributeFilter: ['class'] }); });

      window.addEventListener('resize', function() {
        clearTimeout(window._tuyoThumbsResizeT);
        window._tuyoThumbsResizeT = setTimeout(function() {
          buildTuyoThumbs();
          filterTuyoThumbs();
          moveBadgeToSlider();
          hideOriginalThumbs();
        }, 200);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 300); });
    } else {
      setTimeout(init, 300);
    }
  })();


  // ──────────────────────────────────────────────────────
  // TUYO: Clique nas tabs Todas / Limited / Core com transição suave
  // (tabs são renderizadas server-side em tuyo-bottle-gallery.liquid)
  // ──────────────────────────────────────────────────────
  (function() {
    var TRANSITION_MS = 280;
    function applyFilter(fieldset, linha) {
      if (linha) fieldset.setAttribute('data-tuyo-active-linha', linha);
      else fieldset.removeAttribute('data-tuyo-active-linha');
      var swatches = fieldset.querySelectorAll('.radio__button[data-variant-option-image]');
      swatches.forEach(function(s) {
        var sLinha = s.getAttribute('data-tuyo-linha');
        var shouldShow = !linha || linha.split(',').indexOf(sLinha) >= 0; // TUYO: aba pode agrupar linhas (Limited = Metalizada + Gold)
        if (shouldShow) {
          // mostrar: garantir display, depois remover hiding pra fazer fade-in
          s.style.display = '';
          // Se estava hiding, espera um frame pra remover (transição funciona)
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              s.removeAttribute('data-tuyo-hiding');
            });
          });
        } else {
          // esconder: marca hiding pra fade-out, depois display:none
          s.setAttribute('data-tuyo-hiding', 'true');
          window.setTimeout(function() {
            // só esconde se ainda está marcado como hiding (evita race com clique rápido)
            if (s.getAttribute('data-tuyo-hiding') === 'true') {
              s.style.display = 'none';
            }
          }, TRANSITION_MS);
        }
      });
    }
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.tuyo-color-tab');
      if (!btn) return;
      var tabs = btn.closest('[data-tuyo-color-tabs]');
      var picker = tabs && tabs.parentElement;
      var fieldset = picker && picker.querySelector('.radio__fieldset--variant-option-image');
      if (!fieldset) return;
      tabs.querySelectorAll('.tuyo-color-tab').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var linha = btn.getAttribute('data-tuyo-tab-linha');
      applyFilter(fieldset, linha);
    });
  })();

  // ──────────────────────────────────────────────────────
  // TUYO: Atualiza o "nome da variante" acima do título quando troca a cor
  // E o subtítulo da linha abaixo do título quando troca a opção "Linha"
  // ──────────────────────────────────────────────────────
  (function() {
    function getCheckedForPosition(pos) {
      var sel = '[data-selector-wrapper][data-option-position="' + pos + '"]';
      var wrap = document.querySelector(sel);
      if (!wrap) return null;
      return wrap.querySelector('input[type="radio"]:checked');
    }
    function updateVariantName() {
      var el = document.querySelector('[data-product-variant-name]');
      if (!el) return;
      var checked = getCheckedForPosition(1);
      if (!checked || !checked.value) return;
      // TUYO 13/10: garrafas mostram o nome da LINHA da cor escolhida
      var holder = checked.closest('[data-tuyo-linha]');
      var linha = holder ? holder.getAttribute('data-tuyo-linha') : '';
      var NOMES = { 'Gold': 'Golden Collection', 'Metalizada': 'Downtown', 'Classic': 'Core' };
      el.textContent = NOMES[linha] || checked.value;
    }
    function updateLinhaSubtitle() {
      var el = document.querySelector('[data-product-linha-subtitle]');
      if (!el) return;
      var pos = el.getAttribute('data-linha-option-position');
      if (!pos) return; // metafield-based — não muda no client
      var checked = getCheckedForPosition(parseInt(pos, 10));
      if (checked && checked.value) el.textContent = checked.value;
    }
    function init() {
      document.addEventListener('change', function(e) {
        var t = e.target;
        if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
        var wrap = t.closest('[data-selector-wrapper]');
        if (!wrap) return;
        var pos = wrap.getAttribute('data-option-position');
        if (pos === '1') updateVariantName();
        var linhaEl = document.querySelector('[data-product-linha-subtitle][data-linha-option-position]');
        if (linhaEl && linhaEl.getAttribute('data-linha-option-position') === pos) updateLinhaSubtitle();
      });
      setTimeout(function() { updateVariantName(); updateLinhaSubtitle(); }, 400);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ──────────────────────────────────────────────────────
  // TUYO: Sincroniza padding lateral da tagline com .footer-blocks
  // (assim TUYO e ACOMPANHA alinham exatamente com newsletter e badges)
  // ──────────────────────────────────────────────────────
  (function() {
    function syncTaglineAlignment() {
      var fb = document.querySelector('.footer-blocks');
      var tagline = document.querySelector('.tuyo-footer-tagline');
      if (!fb || !tagline) return;

      var fbCS = getComputedStyle(fb);
      var fbRect = fb.getBoundingClientRect();
      var tagRect = tagline.getBoundingClientRect();
      var fbPadL = parseFloat(fbCS.paddingLeft) || 0;
      var fbPadR = parseFloat(fbCS.paddingRight) || 0;

      // Target: conteúdo da tagline alinha com conteúdo do .footer-blocks
      // (que começa em fbRect.left + fbPadL e termina em fbRect.right - fbPadR)
      var targetContentLeft = fbRect.left + fbPadL;
      var targetContentRight = fbRect.right - fbPadR;

      // Calcula padding necessário para a tagline atingir o target
      var padL = targetContentLeft - tagRect.left;
      var padR = tagRect.right - targetContentRight;

      tagline.style.paddingLeft = Math.max(0, padL) + 'px';
      tagline.style.paddingRight = Math.max(0, padR) + 'px';
    }

    function init() {
      syncTaglineAlignment();
      // Re-sync após renders async (fonts, images, etc)
      setTimeout(syncTaglineAlignment, 200);
      setTimeout(syncTaglineAlignment, 800);
      window.addEventListener('resize', function() {
        clearTimeout(window._tuyoTagSync);
        window._tuyoTagSync = setTimeout(syncTaglineAlignment, 100);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 100); });
    } else {
      setTimeout(init, 100);
    }
  })();

  // ──────────────────────────────────────────────────────
  // TUYO: Move social-icons do bottom-bar pra dentro do menu TUYO
  //  - Em DESKTOP (≥750px): move pra dentro do menu TUYO
  //  - Em MOBILE (<750px): mantém no bottom-bar original
  //  - Reage a resize pra reposicionar
  // ──────────────────────────────────────────────────────
  (function() {
    var MOVE_SOCIAL = true;
    if (!MOVE_SOCIAL) return;

    function findOriginalSocial() {
      return document.querySelector('.footer-bottom .social-sharing-wrapper, .footer-bottom .footer-social, .footer-bottom [class*="social-sharing"]');
    }

    function findHiddenSocial() {
      return document.querySelector('.tuyo-social-hidden');
    }

    function restoreOriginal() {
      var moved = document.querySelector('.tuyo-social-in-menu');
      if (moved) moved.remove();
      var hidden = findHiddenSocial();
      if (hidden) {
        hidden.classList.remove('tuyo-social-hidden');
        hidden.style.removeProperty('display');
      }
    }

    function moveSocialIntoMenu() {
      var original = findOriginalSocial() || findHiddenSocial();
      if (!original) return false;

      var menuBlocks = document.querySelectorAll('.footer-block--menu, .footer-block--link');
      var targetBlock = null;
      menuBlocks.forEach(function(block) {
        var links = block.querySelectorAll('a');
        for (var i = 0; i < links.length; i++) {
          var txt = (links[i].textContent || '').toLowerCase();
          if (txt.indexOf('ambassador') >= 0 || txt.indexOf('nossa história') >= 0 || txt.indexOf('para empresas') >= 0) {
            targetBlock = block;
            return;
          }
        }
      });
      if (!targetBlock) targetBlock = menuBlocks[menuBlocks.length - 1];
      if (!targetBlock) return false;

      if (targetBlock.querySelector('.tuyo-social-in-menu')) return true;

      var clone = original.cloneNode(true);
      clone.classList.add('tuyo-social-in-menu');
      targetBlock.appendChild(clone);

      original.classList.add('tuyo-social-hidden');
      original.style.setProperty('display', 'none', 'important');
      return true;
    }

    function applyByViewport() {
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (isDesktop) {
        moveSocialIntoMenu();
      } else {
        restoreOriginal();
      }
    }

    function init() {
      applyByViewport();
      setTimeout(applyByViewport, 500);
      setTimeout(applyByViewport, 1500);
      window.addEventListener('resize', function() {
        clearTimeout(window._tuyoSocialT);
        window._tuyoSocialT = setTimeout(applyByViewport, 150);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 200); });
    } else {
      setTimeout(init, 200);
    }
  })();

/* ======== bloco-3 ======== */
/* TUYO #3: Zepto — dropdown vira cards + passos numerados dinâmicos (até 4),
     fontes renderizadas na própria tipografia, e grid de ícones.
     Funcionamento do app intacto: cards dirigem o <select> escondido (valor CRU,
     preserva espaços — ex.: "Ícone + Texto Horizontal "). renumber idempotente. */
  (function () {
    'use strict';
    function iconFor(v) {
      v = (v || '').toLowerCase();
      var ic = v.indexOf('\u00edcone') >= 0 || v.indexOf('icone') >= 0, ve = v.indexOf('vertical') >= 0, ho = v.indexOf('horizontal') >= 0;
      if (ic && ve) return '\u2605 \u2195'; if (ic && ho) return '\u2605 \u2194'; if (ic) return '\u2605';
      if (ve) return '\u2195'; if (ho) return '\u2194'; return 'Abc';
    }
    function mark(cards, v) { Array.prototype.forEach.call(cards.querySelectorAll('.tuyo-style-card'), function (c) { c.classList.toggle('is-selected', c.dataset.value === v); }); }
    function applyFonts(pp) {
      pp.querySelectorAll('.pplr-font-select .pplr-selecter-item').forEach(function (b) {
        var ff = b.style.fontFamily; if (ff) b.style.setProperty('font-family', ff, 'important');
      });
    }
    function collectLabels(pp) {
      var labels = [];
      pp.querySelectorAll('.pplr-wrapper').forEach(function (w) {
        if (w.offsetParent === null) return;
        var isDrop = w.classList.contains('pplr-dropdown'),
            isIcon = !!w.querySelector('.pplr-swatch-element'),
            isText = !!w.querySelector('textarea'),
            isFont = w.classList.contains('pplr-font-select');
        if (!(isDrop || isIcon || isText || isFont)) return;
        var lab = w.querySelector('.pplrlabel');
        if (isFont) {
          lab = w.querySelector('.tuyo-font-label');
          if (!lab) { var o = w.querySelector('.pplr-selecter-options'); if (o) { lab = document.createElement('div'); lab.className = 'tuyo-font-label'; lab.textContent = 'Fonte'; o.parentNode.insertBefore(lab, o); } }
        }
        if (lab) labels.push(lab);
      });
      return labels;
    }
    function renumber(pp) {
      var labels = collectLabels(pp);
      var current = pp.querySelectorAll('.tuyo-step-num');
      var ok = current.length === labels.length && labels.every(function (lab, i) {
        var b = lab.querySelector('.tuyo-step-num');
        return b && b.parentNode === lab && lab.firstChild === b && b.textContent === String(i + 1);
      });
      if (ok) return;                       // idempotente: nada a fazer
      current.forEach(function (n) { n.remove(); });
      labels.forEach(function (lab, i) {
        var b = document.createElement('span'); b.className = 'tuyo-step-num'; b.textContent = (i + 1);
        lab.classList.add('tuyo-stepped'); lab.insertBefore(b, lab.firstChild);
      });
    }
    function buildCards(pp) {
      var wrap = pp.querySelector('.pplr-wrapper.pplr-dropdown');
      if (!wrap || wrap.classList.contains('tuyo-carded')) return;
      var sel = wrap.querySelector('select.pplr_select');
      if (!sel || !sel.options.length) return;
      var cards = document.createElement('div'); cards.className = 'tuyo-style-cards';
      Array.prototype.forEach.call(sel.options, function (opt) {
        var v = opt.value;                  // CRU (preserva espaços)
        if (!v || /selecionar/i.test(v)) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tuyo-style-card'; b.dataset.value = v;
        b.innerHTML = '<span class="tuyo-style-card__icon">' + iconFor(v) + '</span><span class="tuyo-style-card__label">' + opt.textContent.trim() + '</span>';
        b.addEventListener('click', function () {
          sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true }));
          mark(cards, sel.value);
          setTimeout(function () { applyFonts(pp); renumber(pp); }, 150);
        });
        cards.appendChild(b);
      });
      if (!cards.children.length) return;
      wrap.classList.add('tuyo-carded'); wrap.appendChild(cards); mark(cards, sel.value);
      sel.addEventListener('change', function () { mark(cards, sel.value); });
    }
    function enhance(pp) { if (!pp.querySelector('select.pplr_select')) return; buildCards(pp); applyFonts(pp); renumber(pp); }
    function watch(pp) {
      if (pp._tuyoWatched) return; pp._tuyoWatched = true;
      enhance(pp);
      var pending = false;
      new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; enhance(pp); }, 80); })
        .observe(pp, { childList: true, subtree: true });
    }
    function scan() { document.querySelectorAll('.product-personalizer').forEach(function (pp) { if (pp.querySelector('select.pplr_select')) watch(pp); }); }
    function init() { scan(); var p = false; new MutationObserver(function () { if (p) return; p = true; setTimeout(function () { p = false; scan(); }, 150); }).observe(document.body, { childList: true, subtree: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

/* ======== bloco-4 ======== */
/* TUYO: Home mobile (<=768px) — título + botão "Ver todos" na mesma linha (baseline), slide/produtos abaixo.
     - "Compre por categoria" (.section-columns__slider): move a coluna de texto p/ acima do slider (revert no desktop).
     - "Best Sellers"/"Lançamentos" (.featured-collection__content.text-left): força flex row inline
       (o tema sobrepõe flex-direction via stylesheet, então setamos inline !important). */
  (function () {
    'use strict';
    var MQ = '(max-width: 768px)';
    // applyAll re-consulta o DOM toda vez (sem cache em array) — assim funciona mesmo
    // quando o customizer re-renderiza a seção (shopify:section:load) com elementos novos.
    function applyAll() {
      var mobile = window.matchMedia(MQ).matches;
      document.querySelectorAll('.section-columns__slider').forEach(function (s) {
        var tc = s.querySelector(':scope > .column-item--text'); // ainda dentro do slider
        var head = (s.previousElementSibling && s.previousElementSibling.classList
                    && s.previousElementSibling.classList.contains('tuyo-mc-head'))
                    ? s.previousElementSibling : null; // já movido p/ fora
        if (mobile) {
          if (!s.dataset.tuyoMcOn && tc) {
            s.parentNode.insertBefore(tc, s); tc.classList.add('tuyo-mc-head'); s.dataset.tuyoMcOn = '1';
          }
        } else {
          if (s.dataset.tuyoMcOn && head) {
            s.insertBefore(head, s.firstChild); head.classList.remove('tuyo-mc-head'); delete s.dataset.tuyoMcOn;
          }
        }
      });
      document.querySelectorAll('.featured-collection__content.text-left').forEach(function (c) {
        if (mobile) {
          c.style.setProperty('display', 'flex', 'important');
          c.style.setProperty('flex-direction', 'row', 'important');
          c.style.setProperty('flex-wrap', 'nowrap', 'important');
          c.style.setProperty('align-items', 'baseline', 'important');
          c.style.setProperty('justify-content', 'space-between', 'important');
        } else {
          ['display', 'flex-direction', 'flex-wrap', 'align-items', 'justify-content'].forEach(function (p) { c.style.removeProperty(p); });
        }
      });
    }
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(applyAll, 150); });
    // Customizer: ao re-renderizar/selecionar a seção, re-aplica o layout mobile
    document.addEventListener('shopify:section:load', function () { setTimeout(applyAll, 50); });
    document.addEventListener('shopify:section:select', function () { setTimeout(applyAll, 50); });
    document.addEventListener('shopify:section:deselect', function () { setTimeout(applyAll, 50); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll); else applyAll();
  })();

/* ======== bloco-5 ======== */
/* TUYO grid-slider reset: no mobile o grid-slider (Lançamentos) vinha com scrollLeft no fim
     (resquício do Flickity), parecendo "se comportar diferente" do Best Sellers. Reseta p/ o início. */
  (function () {
    'use strict';
    function reset() {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      document.querySelectorAll('grid-slider.carousel--mobile').forEach(function (gs) {
        if (gs.classList.contains('carousel--inactive') && gs.scrollLeft !== 0) {
          try { gs.scrollTo({ left: 0, behavior: 'instant' }); } catch (e) {}
          gs.scrollLeft = 0;
        }
      });
    }
    function init() {
      reset(); [150, 500, 1000].forEach(function (t) { setTimeout(reset, t); });
      var x; window.addEventListener('resize', function () { clearTimeout(x); x = setTimeout(reset, 250); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

/* ======== bloco-6 ======== */
/* TUYO: clicar no "+" dos swatches expande os escondidos */
  (function(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-swatch-expand]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var root = btn.closest('product-grid-item-swatch') || btn.parentElement;
      if (!root) return;
      root.querySelectorAll('.swatch__button.is-hidden').forEach(function(el){ el.classList.remove('is-hidden'); });
      btn.style.display = 'none';
    }, true);
  })();

/* ======== bloco-11 ======== */
(function(){
  function getFlkty(el){
    return (window.theme && window.theme.Flickity && window.theme.Flickity.data(el))
        || (window.Flickity && window.Flickity.data && window.Flickity.data(el)) || null;
  }
  function heal(){
    var sliders = document.querySelectorAll('.flickity-slider.variable-products-list');
    for (var i = 0; i < sliders.length; i++){
      var slider = sliders[i];
      var el = slider.closest('.flickity-enabled');
      if (!el) continue;
      var flkty = getFlkty(el);
      if (!flkty || !flkty.cells) continue;
      if (slider.children.length > flkty.cells.length){
        try { flkty.reloadCells(); flkty.resize(); } catch(e){}
      }
    }
  }
  if (document.readyState === 'complete') { heal(); }
  else { window.addEventListener('load', heal, { once: true }); }
  var n = 0, iv = setInterval(function(){ heal(); if (++n >= 16) clearInterval(iv); }, 400);
  document.addEventListener('shopify:section:load', function(){
    var k = 0, j = setInterval(function(){ heal(); if (++k >= 10) clearInterval(j); }, 400);
  });
}());

/* ======== bloco-12 ======== */
/* TUYO: swatch-cols recompute - mobile, 2 fileiras row-major; colunas = metade dos swatches visiveis (tabs Todas/Limited/Core filtram via display:none) */
(function(){
  function setCols(box){
    if (window.innerWidth > 767) { box.style.removeProperty('--tuyo-swatch-cols'); return; }
    var btns = box.querySelectorAll('.radio__button'), vis = 0;
    for (var i=0;i<btns.length;i++){ if (btns[i].offsetParent !== null || btns[i].getClientRects().length) vis++; }
    var cols = Math.max(2, Math.ceil(vis/2));
    if (box.style.getPropertyValue('--tuyo-swatch-cols') !== String(cols)) box.style.setProperty('--tuyo-swatch-cols', cols);
  }
  function position(box, sl){
    var thumb = sl.firstChild;
    var max = box.scrollWidth - box.clientWidth;
    var travel = sl.clientWidth - thumb.offsetWidth;
    var left = max > 0 ? (box.scrollLeft / max) * travel : 0;
    thumb.style.transform = 'translateX(' + left + 'px)';
  }
  function ensureSlider(box){
    var anchor = box.closest('.radio__fieldset--variant-option-image') || box;
    var sl = anchor.nextElementSibling;
    if (sl && sl.classList && sl.classList.contains('tuyo-swatch-slider')) return sl;
    sl = document.createElement('div'); sl.className = 'tuyo-swatch-slider';
    var thumb = document.createElement('div'); thumb.className = 'tuyo-swatch-slider__thumb';
    sl.appendChild(thumb);
    anchor.insertAdjacentElement('afterend', sl);
    box.addEventListener('scroll', function(){ position(box, sl); }, { passive: true });
    var drag = false, sx = 0, ss = 0;
    function down(e){ drag = true; sx = (e.touches ? e.touches[0].clientX : e.clientX); ss = box.scrollLeft; if (e.cancelable) e.preventDefault(); }
    function move(e){
      if (!drag) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX), dx = x - sx;
      var travel = sl.clientWidth - thumb.offsetWidth;
      var ratio = travel > 0 ? (box.scrollWidth - box.clientWidth) / travel : 0;
      box.scrollLeft = ss + dx * ratio;
      if (e.cancelable) e.preventDefault();
    }
    function up(){ drag = false; }
    sl.addEventListener('mousedown', down); sl.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('mousemove', move); window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', up); window.addEventListener('touchend', up);
    return sl;
  }
  function syncSlider(box){
    var sl = ensureSlider(box), thumb = sl.firstChild;
    var scrollable = box.scrollWidth > box.clientWidth + 2;
    if (window.innerWidth > 767 || !scrollable) { sl.style.display = 'none'; return; }
    sl.style.display = 'block';
    if (sl.clientWidth < 10) { requestAnimationFrame(function(){ syncSlider(box); }); return; }
    var w = Math.max(24, (box.clientWidth / box.scrollWidth) * sl.clientWidth);
    thumb.style.width = w + 'px';
    position(box, sl);
  }
  function run(){ var b=document.querySelectorAll('.radio__fieldset--variant-option-image .radio__buttons'); for (var i=0;i<b.length;i++){ setCols(b[i]); syncSlider(b[i]); } }
  if (document.readyState !== 'loading') run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', run);
  document.addEventListener('click', function(){ [50,250,500].forEach(function(d){ setTimeout(run,d); }); }, true);
  document.addEventListener('shopify:section:load', function(){ setTimeout(run,50); });
})();

/* ======== tuyo-mobile-account ======== */
(function () {
  if (window.__tuyoMobileAccount) return;
  window.__tuyoMobileAccount = true;
  /* Já NÃO injetamos a conta no header. Só removemos clones antigos que porventura
     tenham sido inseridos numa versão anterior deste tema (estado persistido/sticky). */
  function cleanup() {
    document.querySelectorAll('.site-header .mobile-menu [data-tuyo-account], .site-header .mobile-menu .tuyo-mobile-account')
      .forEach(function (el) { el.remove(); });
  }
  cleanup();
  document.addEventListener('DOMContentLoaded', cleanup);
  document.addEventListener('shopify:section:load', cleanup);
  var host = document.querySelector('.shopify-section-group-group-header') || document.body;
  try { new MutationObserver(cleanup).observe(host, { childList: true, subtree: true }); } catch (e) {}
})();

/* ======== tuyo-collection-handle-body ======== */
(function () {
    // handle vindo do Liquid (fonte da verdade em pagina de colecao); '' fora de colecao.
    var LIQUID_HANDLE = window.TUYO_COLLECTION_HANDLE;
    function currentHandle() {
      if (LIQUID_HANDLE) return LIQUID_HANDLE;
      var m = (location.pathname || '').match(/\/collections\/([^\/?#]+)/);
      return m ? m[1] : '';
    }
    function setHandle() {
      if (!document.body) return;
      var h = currentHandle();
      if (document.body.getAttribute('data-collection-handle') !== h) {
        document.body.setAttribute('data-collection-handle', h);
      }
    }
    // este snippet roda no <head> → body ainda nao existe; espera o DOM.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setHandle);
    } else {
      setHandle();
    }
    // filtros do tema recarregam via AJAX (mesma URL de coleção); reafirma o handle.
    document.addEventListener('theme:filter:update', setHandle);
    document.addEventListener('shopify:section:load', setHandle);
  })();

/* ======== tuyo-collection-filter-unlock ======== */
(function () {
  if (window.__tuyoFilterUnlock) return;
  window.__tuyoFilterUnlock = true;
  var armedUntil = 0, timer = null;
  function legitLock() { return /js-drawer-open|js-quick-view-visible|search-opened|megamenu-opened/.test(document.body.className); }
  function unlock() {
    if (performance.now() > armedUntil) return;
    if (legitLock()) return; // não mexe em lock de cart/nav/busca/quick-view
    if (document.documentElement.hasAttribute('data-scroll-locked')) {
      // máquina de unlock do próprio tema (scroll-lock lib): clearQueueScrollLocks+enablePageScroll+removeAttr.
      // Disparado várias vezes (via o intervalo) p/ drenar o contador caso o lock tenha sido aplicado +1x.
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }
    // resíduos de lock inline (defensivo)
    var b = document.body;
    if (b.style.overflow === 'hidden') b.style.overflow = '';
    if (b.style.paddingRight) b.style.paddingRight = '';
  }
  function arm() {
    armedUntil = performance.now() + 7000; // cobre AJAX lento; o lock é aplicado durante a troca
    unlock();
    if (!timer) timer = setInterval(function () {
      unlock();
      if (performance.now() > armedUntil) { clearInterval(timer); timer = null; }
    }, 150);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-collection-filters-form], collection-filters')) arm();
  }, true);
  // Pega o lock no exato instante em que <html data-scroll-locked> aparece (só na janela armada).
  try { new MutationObserver(unlock).observe(document.documentElement, { attributes: true, attributeFilter: ['data-scroll-locked'] }); } catch (e) {}
})();

/* ======== tuyo-mobile-solid-header ======== */
(function () {
  if (window.__tuyoSolidHeaderMobile) return;
  window.__tuyoSolidHeaderMobile = true;
  var mq = window.matchMedia('(max-width: 768px)');
  function sync() {
    var sec = document.querySelector('.main-content > .supports-transparent-header:first-child');
    if (!sec) return; // página já é sólida (1ª seção não é hero transparente)
    var marker = sec.querySelector(':scope > [data-tuyo-solid-header]');
    // HOME (template-index) deve continuar TRANSPARENTE no mobile (a pedido) — nunca solidifica.
    if (document.body && document.body.classList.contains('template-index')) {
      if (marker) marker.remove();
      return;
    }
    // COLLECTION: sólido SEMPRE (mobile e desktop) — header não sobrepõe o banner
    var isCollection = document.body && document.body.classList.contains('template-collection');
    if (mq.matches || isCollection) {
      if (!marker) {
        marker = document.createElement('span');
        marker.setAttribute('data-prevent-transparent-header', '');
        marker.setAttribute('data-tuyo-solid-header', '');
        marker.style.display = 'none';
        sec.insertBefore(marker, sec.firstChild);
      }
    } else if (marker) {
      marker.remove();
    }
  }
  function run() { try { sync(); } catch (e) {} }
  run();
  document.addEventListener('DOMContentLoaded', run);
  if (mq.addEventListener) mq.addEventListener('change', run);
  else if (mq.addListener) mq.addListener(run);
  // editor de tema: re-aplica ao carregar/reordenar/selecionar seções
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);
  document.addEventListener('shopify:section:select', run);
})();

/* ======== tuyo-carousel-scrubber ======== */
/* Linha de progresso + setas dos carrosséis de produto — BIMODAL:
     desktop = Flickity (progress/previous/next); mobile = rolagem nativa do
     carousel--mobile (scrollLeft/scrollBy). Auto-esconde quando cabe tudo;
     refresh pega re-render do B4B e troca de modo no resize. */
  (function () {
    var SVG_PREV = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="14 5 7 12 14 19"/></svg>';
    var SVG_NEXT = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="10 5 17 12 10 19"/></svg>';
    function build(slider) {
      if (slider.__tuyoScrub) return;
      slider.__tuyoScrub = true;
      var row = document.createElement('div');
      row.className = 'tuyo-scrub';
      row.style.display = 'none';
      row.innerHTML = '<div class="tuyo-scrub__track"><div class="tuyo-scrub__fill"></div></div>' +
        '<button type="button" class="tuyo-scrub__btn" data-scrub-prev aria-label="Anterior">' + SVG_PREV + '</button>' +
        '<button type="button" class="tuyo-scrub__btn" data-scrub-next aria-label="Próximo">' + SVG_NEXT + '</button>';
      slider.insertAdjacentElement('afterend', row);
      var fill = row.querySelector('.tuyo-scrub__fill');
      var prev = row.querySelector('[data-scrub-prev]');
      var next = row.querySelector('[data-scrub-next]');
      var flkty = null;
      var mode = null;
      function getFlkty() {
        var F = window.theme && window.theme.Flickity;
        var f = F ? F.data(slider) : null;
        return (f && f.isActive) ? f : null;
      }
      function paintFill(p, frac) {
        p = Math.max(0, Math.min(1, p || 0));
        if (!isFinite(frac) || frac <= 0) frac = 0.15;
        frac = Math.min(1, frac);
        fill.style.width = ((frac + p * (1 - frac)) * 100) + '%';
      }
      function paintFlktyProgress(p) {
        paintFill(p, flkty && flkty.slideableWidth > 0 ? slider.clientWidth / flkty.slideableWidth : 0.15);
      }
      function paintFlktyButtons() {
        if (!flkty) return;
        prev.disabled = flkty.selectedIndex === 0;
        next.disabled = flkty.selectedIndex >= flkty.slides.length - 1;
      }
      function paintScroll() {
        var max = slider.scrollWidth - slider.clientWidth;
        if (max <= 4) { row.style.display = 'none'; return; }
        row.style.display = '';
        paintFill(slider.scrollLeft / max, slider.scrollWidth > 0 ? slider.clientWidth / slider.scrollWidth : 0.15);
        prev.disabled = slider.scrollLeft <= 2;
        next.disabled = slider.scrollLeft >= max - 2;
      }
      slider.addEventListener('scroll', function () { if (mode === 'scroll') paintScroll(); }, { passive: true });
      prev.addEventListener('click', function () {
        if (mode === 'flickity' && flkty) flkty.previous();
        else slider.scrollBy({ left: -slider.clientWidth * 0.85, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        if (mode === 'flickity' && flkty) flkty.next();
        else slider.scrollBy({ left: slider.clientWidth * 0.85, behavior: 'smooth' });
      });
      function refresh() {
        var f = getFlkty();
        if (f) {
          mode = 'flickity';
          if (f !== flkty) { flkty = f; flkty.on('scroll', paintFlktyProgress); flkty.on('select', paintFlktyButtons); }
          if (f.slides.length <= 1) { row.style.display = 'none'; return; }
          row.style.display = '';
          paintFlktyProgress(f.slides.length > 1 ? f.selectedIndex / (f.slides.length - 1) : 0);
          paintFlktyButtons();
        } else {
          mode = 'scroll';
          paintScroll();
        }
      }
      slider.__tuyoScrubRefresh = refresh;
      refresh();
    }
    function scan() {
      document.querySelectorAll('.featured-collection__container grid-slider').forEach(function (s) {
        try { s.__tuyoScrub ? s.__tuyoScrubRefresh && s.__tuyoScrubRefresh() : build(s); } catch (e) {}
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    window.addEventListener('resize', scan, { passive: true });
    setTimeout(scan, 800);
    setTimeout(scan, 2000);
    setInterval(scan, 2500);
  })();

/* ======== tuyo-card-stanley-js ======== */
/* Linha "tamanho | cor" do card:
     (a) no load, casa o rótulo com a VARIANTE que o card representa (o tema/app
         expande cada cor num card próprio via ?variant=; a 1ª cor da lista NÃO serve);
     (b) atualiza ao clicar/passar nos swatches. */
  (function () {
    function nameForVariant(card, vid) {
      if (!vid) return null;
      // fonte primária: o mapa data-tuyo-prices (traz o nome junto — sempre
      // consistente com o preço; alguns cards não têm o swatch da variante)
      var script = card.querySelector('script[data-tuyo-prices]');
      if (script) {
        try {
          var m = JSON.parse(script.textContent);
          if (m[vid] && m[vid][2]) return m[vid][2];
        } catch (e) {}
      }
      var sw = card.querySelector('[data-swatch-variant="' + vid + '"]');
      if (!sw) return null;
      return (sw.getAttribute('data-swatch')
        || (sw.closest('[data-swatch-button]') && sw.closest('[data-swatch-button]').getAttribute('data-value'))
        || null);
    }
    function variantOf(card) {
      // clique manual num swatch tem prioridade sobre o ?variant= do link
      var chosen = card.getAttribute('data-tuyo-chosen');
      if (chosen) return chosen;
      var link = card.querySelector('[data-grid-link][href*="variant="]')
              || card.querySelector('a[href*="/products/"][href*="variant="]');
      return link && (link.getAttribute('href').match(/variant=(\d+)/) || [])[1];
    }
    function money(cents) {
      var n = cents / 100;
      if (n % 1 === 0) return 'R$ ' + n;
      return 'R$ ' + n.toFixed(2).replace('.', ',');
    }
    function fixPrice(card, vid) {
      var el = card.querySelector('.product-grid-item__price');
      if (!el || !vid) return;
      var script = card.querySelector('script[data-tuyo-prices]');
      if (!script) return;
      var map;
      try { map = JSON.parse(script.textContent); } catch (e) { return; }
      var entry = map[vid];
      if (!entry) return;
      var price = entry[0], compare = entry[1];
      // só re-monta se a variante mudou OU a app apagou nosso markup (evita loop)
      if (el.getAttribute('data-tuyo-price') === String(vid) && el.querySelector('.tuyo-price')) return;
      var html = '<span class="tuyo-price">' + money(price) + '</span>';
      if (compare && compare > price) html += '<s class="tuyo-price-compare">' + money(compare) + '</s>';
      el.innerHTML = html;
      el.setAttribute('data-tuyo-price', String(vid));
      // (badges — inclusive o de desconto — agora são tratados por fixBadges)
    }
    /* Badges POR VARIANTE do card (13/jul): o liquid só enxerga a 1ª variante do
       produto, então cards de outras cores não ganhavam BEST SELLER/NEW IN/ED.
       LIMITADA (nem %OFF quando só a cor do card tem desconto). As flags vêm no 4º
       campo do mapa data-tuyo-prices ("b"/"n"/"l"). Cria/atualiza/esconde os itens
       — inclusive o contêiner .product-badge quando o server não renderizou nenhum.
       Idempotente (só escreve quando muda) — roda no interval sem piscar. */
    function fixBadges(card, vid) {
      if (!vid) return;
      var script = card.querySelector('script[data-tuyo-prices]');
      if (!script) return;
      var map;
      try { map = JSON.parse(script.textContent); } catch (e) { return; }
      var entry = map[vid];
      if (!entry) return;
      var flags = entry[3] || '';
      var price = entry[0], compare = entry[1];
      var pct = (compare && compare > price) ? Math.round((compare - price) * 100 / compare) : 0;
      var want = [
        ['bestseller', flags.indexOf('b') > -1, 'BEST SELLER'],
        ['newin', flags.indexOf('n') > -1, 'NEW IN'],
        ['limited', flags.indexOf('l') > -1, 'ED. LIMITADA'],
        ['discount', pct > 0, pct + '% OFF']
      ];
      var box = card.querySelector('.product-badge');
      var any = want.some(function (w) { return w[1]; });
      if (!box) {
        if (!any) return;
        box = document.createElement('div');
        box.className = 'product-badge';
        var qb = card.querySelector('.product-grid-item__quick-buy');
        var mediaLink = card.querySelector('a[data-grid-link]');
        if (qb && qb.parentElement) qb.parentElement.insertBefore(box, qb);
        else if (mediaLink && mediaLink.parentElement) mediaLink.insertAdjacentElement('afterend', box);
        else card.appendChild(box);
      }
      want.forEach(function (w) {
        var item = box.querySelector('.product-badge__item--' + w[0]);
        if (w[1]) {
          if (!item) {
            item = document.createElement('div');
            item.className = 'product-badge__item product-badge__item--' + w[0];
            item.innerHTML = '<span></span>';
            box.appendChild(item);
          }
          var span = item.querySelector('span') || item;
          if (span.textContent !== w[2]) span.textContent = w[2];
          if (item.style.display) item.style.removeProperty('display');
        } else if (item && item.style.display !== 'none') {
          item.style.display = 'none';
        }
      });
    }
    function fixCard(card) {
      var vid = variantOf(card);
      var lbl = card.querySelector('[data-variant-label-color]');
      if (lbl) {
        var name = nameForVariant(card, vid);
        if (name && lbl.textContent !== name) lbl.textContent = name;
      }
      fixPrice(card, vid);
      fixBadges(card, vid);
    }
    function fixAll() {
      document.querySelectorAll('.product-grid-item').forEach(function (card) {
        try { fixCard(card); } catch (e) { /* um card quebrado não pode parar os outros */ }
      });
    }
    function apply(e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-swatch-button]');
      if (!btn) return;
      var card = btn.closest('.product-grid-item');
      if (!card) return;
      var lbl = card.querySelector('[data-variant-label-color]');
      if (lbl && btn.dataset.value) lbl.textContent = btn.dataset.value;
      // ao CLICAR num swatch, o card passa a representar aquela variante:
      // preço acompanha E a foto troca (o tema não trocava a imagem sozinho aqui)
      if (e.type === 'click') {
        var sw = btn.querySelector('[data-swatch-variant]');
        var vid = sw && sw.getAttribute('data-swatch-variant');
        if (vid) { card.setAttribute('data-tuyo-chosen', vid); try { fixPrice(card, vid); fixBadges(card, vid); } catch (err) {} }
        var imgUrl = sw && sw.getAttribute('data-swatch-image');
        if (imgUrl) {
          var mainImg = card.querySelector('.product-grid-item__image img');
          if (mainImg) {
            var pic = mainImg.closest('picture');
            if (pic) pic.querySelectorAll('source').forEach(function (so) { so.remove(); });
            mainImg.removeAttribute('srcset');
            mainImg.src = imgUrl + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=800';
          }
        }
      }
    }
    document.addEventListener('click', apply, true);
    document.addEventListener('mouseover', apply, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixAll);
    else fixAll();
    // cards podem entrar depois (scroll infinito / filtro) — observa e recorrige (debounce)
    var moTimer = null;
    var mo = new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () { moTimer = null; fixAll(); }, 250);
    });
    // GOTCHA: este script roda no <head> (tuyo-settings) — document.body ainda
    // NÃO existe aqui; observe(document.body) lançava e matava o resto do IIFE
    // (interval/timeouts nunca registravam → após AJAX de sort nada re-aplicava).
    // documentElement sempre existe. Interval registrado ANTES de qualquer risco.
    setInterval(fixAll, 1500); // rede de segurança idempotente (guards de igualdade)
    setTimeout(fixAll, 800);
    setTimeout(fixAll, 1800);
    document.addEventListener('theme:filters:loaded', fixAll);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();

/* ======== tuyo-swatch-arrows ======== */
/* SETAS do slider de swatches — 4 estados por posicao de scroll (o native-scrollbar
     do tema nao estava alternando de forma confiavel neste contexto; aqui garantimos):
       A) sem overflow           -> prev e next escondidos;
       B) inicio (scrollLeft~0)  -> so next;
       C) meio                   -> ambos;
       D) fim (scrollLeft~max)   -> so prev.
     Só alterna a classe .is-hidden (display:none). NAO mexe no clique/rolagem: o
     native-scrollbar mantem os bindings data-scrollbar-arrow-* (navegacao intacta). */
  (function () {
    var EPS = 2;
    function arrowsFor(track) {
      var fs = track.closest('.product-grid-item__fieldset') || track.parentElement;
      if (!fs) return null;
      return {
        prev: fs.querySelector('.product-grid-item__fieldset__arrow--prev'),
        next: fs.querySelector('.product-grid-item__fieldset__arrow--next')
      };
    }
    function update(track) {
      var a = arrowsFor(track);
      if (!a || !a.prev || !a.next) return;
      var overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= EPS) { a.prev.classList.add('is-hidden'); a.next.classList.add('is-hidden'); return; }
      var atStart = track.scrollLeft <= EPS;
      var atEnd = track.scrollLeft >= overflow - EPS;
      a.prev.classList.toggle('is-hidden', atStart);
      a.next.classList.toggle('is-hidden', atEnd);
    }
    function bind(track) {
      if (track.__tuyoArrowsBound) { update(track); return; }
      track.__tuyoArrowsBound = true;
      track.addEventListener('scroll', function () { update(track); }, { passive: true });
      update(track);
    }
    function scan() {
      document.querySelectorAll('.product-grid-item__swatch--slider').forEach(bind);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    // recomputa quando o layout muda (2-col<->4-col, app injeta cards, filtros recarregam)
    document.addEventListener('theme:resize', scan);
    window.addEventListener('resize', scan, { passive: true });
    document.addEventListener('theme:filters:loaded', scan);
    setTimeout(scan, 800);
    setTimeout(scan, 1800);
    setInterval(scan, 1500); // idempotente (guard __tuyoArrowsBound); pega cards novos do app
  })();

/* ======== tuyo-collection-v2-js ======== */
/* "Ordenar por": fecha o dropdown no load (o tema abre os grupos) e injeta a
     opção "Descontos" — ordena os produtos carregados por % OFF (badge do card). */
  (function () {
    // ── Dropdown via PORTAL: o painel original é clipado dentro da caixa dos
    //    filtros (contain/paint do tema), então ao abrir clonamos o painel para
    //    o <body> (#TuyoSortGhost, fixed, z-index máximo). Cliques no ghost
    //    repassam aos inputs ORIGINAIS (que ficam no form — o tema escuta o
    //    change e aplica o sort). Delegação no document = sobrevive a AJAX. ──
    function setIcon(sort, open) {
      var t = sort.querySelector('.collection__sort__label');
      if (t) { t.classList.toggle('is-expanded', open); t.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    }
    var activeSort = null;
    function closeGhost() {
      var g = document.getElementById('TuyoSortGhost');
      if (g) g.remove();
      activeSort = null;
      document.querySelectorAll('.collection__sort').forEach(function (s) { setIcon(s, false); });
    }
    function openGhost(sort) {
      if (window.Shopify && Shopify.designMode) return; // sem portal dentro do editor
      closeGhost();
      injectDesconto(); // o re-render AJAX dos filtros apaga o li injetado — garante na abertura
      activeSort = sort;
      var trg = sort.querySelector('.collection__sort__label');
      var panel = sort.querySelector('#CollectionSorting');
      if (!trg || !panel) return;
      var g = panel.cloneNode(true);
      g.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
      // estilos inline do colapsável do tema (height/opacity travados no momento
      // do clone) cortavam a última opção — o ghost dimensiona pelo conteúdo
      g.removeAttribute('style');
      g.querySelectorAll('[style]').forEach(function (e) { e.removeAttribute('style'); });
      g.id = 'TuyoSortGhost';
      var r = trg.getBoundingClientRect();
      g.style.top = (r.bottom + 6) + 'px';
      g.style.left = (r.left + r.width / 2) + 'px';
      document.body.appendChild(g);
      // clamp horizontal: no mobile o botão fica perto da borda e o menu
      // centralizado (translateX -50%) saía da tela cortando o texto
      (function () {
        var half = (g.offsetWidth || 230) / 2;
        var x = r.left + r.width / 2;
        x = Math.max(8 + half, Math.min(window.innerWidth - 8 - half, x));
        g.style.left = x + 'px';
      })();
      // altura pelo CONTEÚDO custe o que custar: alguma regra do tema (via classe
      // do wrapper) trava height fixa e cortava a última opção
      [g, g.querySelector('.collection__sort__options'), g.querySelector('ul')].forEach(function (el) {
        if (!el) return;
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        // o tema deixa um translateY de animação no options → conteúdo desenhava
        // 26px abaixo da caixa e cortava a última opção
        if (el !== g) el.style.setProperty('transform', 'none', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
      });
      g.style.setProperty('overflow', 'hidden', 'important'); // mantém o radius do card
      setIcon(sort, true);
      g.addEventListener('click', function (e) {
        var d = e.target.closest('.tuyo-sort-desconto');
        if (d) {
          e.preventDefault();
          var ob = sort.querySelector('.tuyo-sort-desconto');
          if (ob) ob.classList.add('is-active');
          reorder();
          closeGhost();
          return;
        }
        var lab = e.target.closest('label');
        if (lab) {
          e.preventDefault();
          var li = lab.closest('li');
          var inp = li && li.querySelector('input');
          if (inp) {
            var orig = sort.querySelector('input[value="' + inp.value + '"]');
            if (orig) {
              orig.checked = true;
              orig.dispatchEvent(new Event('change', { bubbles: true }));
              orig.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
          closeGhost();
        }
      });
    }
    document.addEventListener('click', function (e) {
      /* 13/jul: cliques SINTÉTICOS do tema (show-more/colapsáveis disparam .click()
         no load) abriam o dropdown sozinho — só clique de gente de verdade conta */
      if (!e.isTrusted) return;
      var trg = e.target.closest && e.target.closest('.collection__sort__label');
      if (trg) {
        var sort = trg.closest('.collection__sort');
        if (sort) {
          e.preventDefault();
          e.stopPropagation();
          if (document.getElementById('TuyoSortGhost')) closeGhost();
          else openGhost(sort);
        }
        return;
      }
      if (e.target.closest && e.target.closest('#TuyoSortGhost')) return; // tratado no listener do ghost
      closeGhost();
    }, true);
    // scroll REPOSICIONA o ghost. Em CAPTURE no document: a página rola num
    // container interno (scroll não borbulha; window não vê) e o menu ficava
    // órfão longe do botão. Fecha só se o trigger sair da viewport.
    function repositionGhost() {
      var g = document.getElementById('TuyoSortGhost');
      if (!g || !activeSort) return;
      var trg = activeSort.querySelector('.collection__sort__label');
      if (!trg) { closeGhost(); return; }
      var r = trg.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) { closeGhost(); return; }
      g.style.top = (r.bottom + 6) + 'px';
      var half = (g.offsetWidth || 230) / 2;
      var x = r.left + r.width / 2;
      x = Math.max(8 + half, Math.min(window.innerWidth - 8 - half, x));
      g.style.left = x + 'px';
    }
    document.addEventListener('scroll', repositionGhost, { capture: true, passive: true });
    window.addEventListener('resize', repositionGhost, { passive: true });

    // Injeta a opção "Descontos" (idempotente; re-roda após re-render dos filtros)
    function injectDesconto() {
      var sort = document.querySelector('.collection__filters .collection__sort');
      if (!sort) return;
      var list = sort.querySelector('ul');
      if (!list || list.querySelector('.tuyo-sort-desconto')) return;
      var li = document.createElement('li');
      li.className = 'collection__filter-tag';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tuyo-sort-desconto';
      btn.textContent = 'Descontos';
      li.appendChild(btn);
      var best = list.querySelector('input[value="best-selling"]');
      list.insertBefore(li, best ? best.closest('li') : list.firstChild);
    }

    function discountOf(item) {
      var badge = item.querySelector('[class*="badge"], .product-grid-item__badge');
      var m = (badge ? badge.textContent : '').match(/(\d+)\s*%/);
      return m ? parseInt(m[1], 10) : 0;
    }
    function reorder() {
      if (window.Shopify && Shopify.designMode) return; // não bagunçar o editor de tema
      var parents = new Set();
      document.querySelectorAll('.product-grid-item').forEach(function (i) { parents.add(i.parentElement); });
      parents.forEach(function (parent) {
        var kids = [].slice.call(parent.querySelectorAll(':scope > .product-grid-item'));
        if (kids.length < 2) return;
        kids.sort(function (a, b) { return discountOf(b) - discountOf(a); })
            .forEach(function (k) { parent.appendChild(k); });
      });
    }

    /* 13/jul: alinha o TOPO do "Ordenar por" com a fileira de pills do 1º grupo —
       mede a posição real (título + respiros), então vale pra qualquer coleção,
       qualquer altura de grupo (fix do desalinho na GARRAFAS). Inline !important
       porque a folha tem margin: 0 !important no .collection__sort. Só desktop. */
    function alignSort() {
      var s = document.querySelector('.collection__filters .collection__sort');
      if (!s) return;
      if (!window.matchMedia('(min-width: 769px)').matches) {
        if (s.style.marginTop) s.style.removeProperty('margin-top');
        return;
      }
      var group = document.querySelector('.collection__filters .collection__filter');
      var wrap = group && group.querySelector('.collection__filter-tags-wrapper');
      if (!group || !wrap) return;
      var rowTop = Math.round(wrap.getBoundingClientRect().top - group.getBoundingClientRect().top);
      if (rowTop < 0 || rowTop > 80) rowTop = 0; /* medida absurda = layout em transição; não desloca */
      var cur = parseFloat(s.style.marginTop || '0');
      if (Math.abs(cur - rowTop) > 0.5) s.style.setProperty('margin-top', rowTop + 'px', 'important');
    }
    window.addEventListener('resize', alignSort, { passive: true });
    /* 13/jul: garante dropdown FECHADO no load e após re-render dos filtros
       (cinto e suspensório além do guard de isTrusted acima) */
    function boot() { injectDesconto(); closeGhost(); alignSort(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('theme:filters:loaded', boot);
    setTimeout(boot, 800);
    setTimeout(boot, 1800);
  })();

/* ======== tuyo-color-single-select ======== */
/* 13/jul: filtro de COR com seleção ÚNICA (estilo radio) — dava pra marcar várias
     cores ao mesmo tempo, anti-intuitivo. Em CAPTURE no document: desmarca as outras
     ANTES do tema serializar o form e aplicar o filtro (o change original segue o
     fluxo normal). Só desmarca inputs do MESMO filtro (name igual) — os de tamanho
     continuam podendo combinar. Delegação no document = sobrevive ao re-render AJAX.
     Clicar na cor já marcada desmarca (volta a mostrar tudo). */
  (function () {
    document.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || !inp.classList || !inp.classList.contains('swatch__input')) return;
      if (!inp.closest('.collection__filter')) return;
      if (!inp.checked) return;
      document.querySelectorAll('.collection__filter .swatch__input:checked').forEach(function (o) {
        if (o !== inp && o.name === inp.name) o.checked = false;
      });
    }, true);
  })();

/* ======== tuyo-brinde-drunk ======== */
/* 24/set/2026 — Tuyo x Drunk Elephant: acima de R$ 599 o cliente ganha o sérum
     bronzeador D-Bronzi 30ml. O brinde é o produto oculto 10497192362300
     (variante 54450387845436), preço R$ 0 com compare-at R$ 356 e estoque 182.
     Este bloco ADICIONA e REMOVE a linha sozinho e pinta a régua no carrinho.
     Régua = cart.total_price (produtos, já com cupom aplicado, sem frete).
     Quando o estoque acaba o /cart/add devolve 422 → SEM_ESTOQUE e a régua some. */
  (function () {
    /* 24/set, fim do dia: promo DESLIGADA a pedido do cliente enquanto o fiscal
         (brinde no Tiny) nao esta resolvido. Religar = LIGADO = true.
         O produto tambem esta em DRAFT e o slide saiu da home — ver
         backups/brinde-drunk-2026-09-24/RELIGAR.py. */
    var LIGADO = true;
    if (!LIGADO) return;

    var VARIANTE = 54450387845436;
    var LIMITE = 59900; // centavos
    var NOME = 'sérum bronzeador D-Bronzi da Drunk Elephant';

    var interno = 0;      // requisições nossas — o interceptador ignora
    var ocupado = false;
    var semEstoque = false;
    var estado = null;    // { base, tem, itens }
    var pintando = null;

    function brl(c) {
      var p = (Math.round(c) / 100).toFixed(2).split('.');
      var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return 'R$ ' + i + (p[1] === '00' ? '' : ',' + p[1]);
    }

    function req(url, opt) {
      interno++;
      var baixa = function () { interno = Math.max(0, interno - 1); };
      return fetch(url, opt).then(function (r) { baixa(); return r; },
                                  function (e) { baixa(); throw e; });
    }

    function postJSON(url, body) {
      return req(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }

    function redesenhaCarrinho() {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.querySelectorAll('cart-element[data-cart-page]').forEach(function (el) {
        if (typeof el.getCart === 'function') { try { el.getCart(); } catch (e) {} }
      });
    }

    function sincroniza() {
      if (ocupado) return Promise.resolve();
      ocupado = true;
      return req('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var linha = null;
          (cart.items || []).forEach(function (it) { if (it.variant_id === VARIANTE) linha = it; });
          var base = cart.total_price || 0;
          var outros = (cart.items || []).length - (linha ? 1 : 0);
          estado = { base: base, tem: !!linha, itens: outros };

          if (outros > 0 && base >= LIMITE && !linha && !semEstoque) {
            return postJSON('/cart/add.js', {
              items: [{ id: VARIANTE, quantity: 1, properties: { _brinde: 'drunk-elephant' } }]
            }).then(function (r) {
              if (!r.ok) { semEstoque = true; return; }   // 422 = esgotado
              estado.tem = true;
              redesenhaCarrinho();
            });
          }

          if (linha && (outros === 0 || base < LIMITE || linha.quantity !== 1)) {
            var q = (outros === 0 || base < LIMITE) ? 0 : 1;
            return postJSON('/cart/change.js', { id: linha.key, quantity: q })
              .then(function () { estado.tem = q > 0; redesenhaCarrinho(); });
          }
        })
        .catch(function () {})
        .then(function () { ocupado = false; pinta(); });
    }

    function html(base, tem) {
      var falta = LIMITE - base;
      var pct = Math.max(0, Math.min(100, Math.round((base / LIMITE) * 100)));
      var presente = '<svg class="tuyo-brinde__ico" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
        '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
      var texto = tem || falta <= 0
        ? presente + ' Você ganhou um <strong>' + NOME + '</strong>.'
        : presente + ' Faltam <strong>' + brl(falta) + '</strong> para ganhar um ' + NOME + '.';
      return '<span class="tuyo-brinde__txt">' + texto + '</span>' +
             '<span class="tuyo-brinde__holder"><span class="tuyo-brinde__bar" style="width:' + pct + '%"></span></span>';
    }

    function alvos() {
      var out = [];
      document.querySelectorAll('[data-cart-drawer-body], .cart__page-wrapper, [data-cart-page]').forEach(function (el) {
        var ancora = el.querySelector('[data-items-holder]');
        if (ancora && out.indexOf(ancora) < 0) out.push(ancora);
      });
      return out;
    }

    function pinta() {
      if (!estado) return;
      var mostrar = !semEstoque && estado.itens > 0;
      alvos().forEach(function (ancora) {
        var msg = ancora.parentNode.querySelector('.tuyo-brinde');
        if (!mostrar) { if (msg) msg.remove(); return; }
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'cart-message tuyo-brinde';
          ancora.parentNode.insertBefore(msg, ancora);
        }
        var pronto = estado.tem || estado.base >= LIMITE;
        if (msg.classList.contains('tuyo-brinde--ok') !== pronto) msg.classList.toggle('tuyo-brinde--ok', pronto);
        var novo = html(estado.base, pronto);
        if (msg.getAttribute('data-h') !== novo) { msg.innerHTML = novo; msg.setAttribute('data-h', novo); }
      });
    }

    function agenda() {
      clearTimeout(pintando);
      pintando = setTimeout(function () { sincroniza(); }, 120);
    }

    // --- escuta qualquer mexida no carrinho (tema, Zepto, personalizador próprio) ---
    var mexeu = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var fetchOriginal = window.fetch;
    if (typeof fetchOriginal === 'function') {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var nosso = interno > 0;
        return fetchOriginal.apply(this, arguments).then(function (r) {
          if (!nosso && mexeu.test(url)) agenda();
          return r;
        });
      };
    }
    var sendOriginal = XMLHttpRequest.prototype.send;
    var openOriginal = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { this.__tuyoUrl = u || ''; return openOriginal.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener('load', function () { if (mexeu.test(xhr.__tuyoUrl || '')) agenda(); });
      return sendOriginal.apply(this, arguments);
    };

    /* a PDP do brinde existe só porque o /cart/add exige o produto publicado.
         Sem o form ninguém consegue se servir sozinho por fora da régua. */
    function trancaPdp() {
      if (document.body.className.indexOf('template-product') < 0) return;
      if (location.pathname.indexOf('brinde-d-bronzi-drunk-elephant') < 0) return;
      document.querySelectorAll('[data-product-form], .product__submit__holder, product-form, .shopify-payment-button')
        .forEach(function (el) { el.style.display = 'none'; });
      var t = document.querySelector('.product__title, .product-single__title');
      if (t && !document.querySelector('.tuyo-brinde-aviso')) {
        var p = document.createElement('p');
        p.className = 'tuyo-brinde-aviso';
        p.textContent = 'Brinde da ação Tuyo x Drunk Elephant — entra sozinho no carrinho nas compras acima de R$ 599, enquanto durar o estoque.';
        t.parentNode.insertBefore(p, t.nextSibling);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trancaPdp);
    else trancaPdp();

    document.addEventListener('theme:cart:loaded', pinta);
    document.addEventListener('theme:cart:open', pinta);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincroniza);
    else sincroniza();

    // o tema reconstrói o drawer inteiro a cada update → devolve a régua ao lugar
    var obs = new MutationObserver(function () { pinta(); });
    function observa() {
      var d = document.getElementById('cart-drawer');
      if (d) obs.observe(d, { childList: true, subtree: true });
      var p = document.querySelector('cart-element[data-cart-page]');
      if (p) obs.observe(p, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observa);
    else observa();
  })();


  // ──────────────────────────────────────────────────────
  // TUYO 13/10: seletor de cor das garrafas no DESKTOP mostra 3 linhas e rola a partir da 4ª
  // (altura medida no DOM: as linhas variam quando o nome da cor quebra em 2 linhas)
  // ──────────────────────────────────────────────────────
  (function() {
    var MQ = window.matchMedia('(min-width: 990px)');
    var PEEK = 28; // pontinha da 4ª linha aparecendo = dica de que rola
    function ajustar() {
      document.querySelectorAll('.tuyo-bottle-picker [data-variant-buttons]').forEach(function(w) {
        w.classList.remove('tuyo-scroll-cores'); w.style.maxHeight = '';
        if (!MQ.matches) return;
        var itens = [].slice.call(w.querySelectorAll('.radio__button')).filter(function(s) { return s.offsetParent && s.style.display !== 'none'; });
        var topos = [];
        itens.forEach(function(i) { var t = Math.round(i.offsetTop); if (topos.indexOf(t) < 0) topos.push(t); });
        topos.sort(function(a, b) { return a - b; });
        if (topos.length <= 3) return;
        w.style.maxHeight = (topos[3] - topos[0] + PEEK) + 'px';
        w.classList.add('tuyo-scroll-cores');
      });
    }
    function depois() { setTimeout(ajustar, 350); }
    document.addEventListener('click', function(e) { if (e.target.closest('.tuyo-color-tab')) depois(); });
    window.addEventListener('resize', depois);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', depois); else depois();
    window.addEventListener('load', depois);
  })();

  document.addEventListener('scroll', function(e) {
    var w = e.target; if (!w.classList || !w.classList.contains('tuyo-scroll-cores')) return;
    w.classList.toggle('no-fim', w.scrollTop + w.clientHeight >= w.scrollHeight - 4);
  }, true);
